import httpUserClient from '@/plugins/httpUserClient';

export default {
  getNotifications(catalog) {
    return httpUserClient.get(`notifications?page=1&per_page=10000&catalog=${catalog}`);
  },
  showNotification(id) {
    return httpUserClient.get(`notifications/${id}`);
  },
  showTrain(id) {
    return httpUserClient.get(`train/activities/${id}`);
  },
  showTrainTake(id) {
    return httpUserClient.get(`user/train/activities/${id}`);
  },
  showUserTrain(id) {
    return httpUserClient.get(`user/train/entries/${id}`);
  },
  entryTrain(id) {
    return httpUserClient.post(`user/train/activities/${id}/entries`);
  },
  pachTrain(entryId) {
    return httpUserClient.put(`/user/train/entries/${entryId}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/userApis/train/userNotificationTrainApi.js